import { ContentType } from "./contents/content-type"

export const Step = (form) => {
  return (
    <div id={`step-${form.stepId}`} class={`step ${form.class}`}>
      {form.step.title && <h1>{form.step.title}</h1>}
      {form.step.contents?.map((obj, i) => {
        return (
          <ContentType
            {...obj}
            form={form}
            key={`${form.stepId}-${obj.type}-${i}`}
          />
        )
      })}
    </div>
  )
}
